module.exports = __webpack_public_path__ + "components/Modals/MeasureTools/icons/powierzchnia.png?c7801023";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/MeasureTools/icons/powierzchnia.png
// module id = 2404
// module chunks = 0